import React, {useEffect, useRef, useState} from 'react';
import {Card, CardContent} from '@mui/material';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import {COLORS} from '@/utils/constants';

interface Props {
	final: any[];
}

const CATEGORIES = [
	{name: 'Family & friends', question: 'question51'},
	{name: 'Business Angels', question: 'question57'},
	{name: 'Crowdfunding', question: 'question62'},
	{name: 'Incubators and Accelerators', question: 'question67'},
	{name: 'NGO’s loans', question: 'question72'},
	{name: 'NGO’s grants', question: 'question77'},
	{name: 'Public subsidies', question: 'question82'},
	{name: 'Public grants', question: 'question87'},
	{name: 'Venture capital', question: 'question92'},
	{name: 'Microfinance', question: 'question97'},
	{name: 'Financial institutions (banks)', question: 'question102'},
	{name: 'Other', question: 'question107'},
];

const FACTORS = [
	{name: 'Issues related to the business model', value: 'Item 1', color: COLORS.e4ImpactBlue},
	{name: 'The requested amount was too high', value: 'Item 2', color: COLORS.orange},
	{name: 'The skills of the team were not strong enough', value: 'Item 3', color: COLORS.gray},
	{name: 'I don\'t know', value: 'Item 4', color: COLORS.yellow},
	{name: 'Other', value: 'other', color: COLORS.blue},
];

const MainFailureFactors = ({final}: Props) => {
	const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
	const [options, setOptions] = useState<Highcharts.Options>();

	const calculateSubmissions = () => {
		const data: Record<string, Record<string, number>> = {};
		FACTORS.forEach((factor) => {
			data[factor.value] = {};
			CATEGORIES.forEach((category) => {
				data[factor.value][category.question] = 0;
			});
		});

		final.forEach((submission) => {
			CATEGORIES.forEach((category) => {
				const answers = Object.keys(submission)
					.filter((key) => key === category.question)
					.map((key) => submission[key])
					.filter(Boolean);

				answers.forEach((answer) => {
					if (data[answer]) {
						data[answer][category.question] += 1;
					} else {
						data.other[category.question] += 1;
					}
				});
			});
		});

		const series = FACTORS.map((factor) => ({
			type: 'bar' as const,
			name: factor.name,
			color: factor.color,
			data: CATEGORIES.map((category) => data[factor.value][category.question]),
		}));

		setOptions({
			chart: {type: 'bar'},
			title: {text: 'KPI: Main failure factors', align: 'left'},
			xAxis: {categories: CATEGORIES.map((c) => c.name)},
			yAxis: {title: {text: null}},
			legend: {verticalAlign: 'bottom'},
			plotOptions: {
				bar: {
					stacking: undefined,
					dataLabels: {enabled: false}
				},
			},
			series,
		});
	};

	useEffect(() => {
		calculateSubmissions();
	}, [final]);

	return (
		<Card className='chart-container'>
			<CardContent>
				{options && <HighchartsReact highcharts={Highcharts} options={options} ref={chartComponentRef} />}
			</CardContent>
		</Card>
	);
};

export default MainFailureFactors;